import styled from 'styled-components';

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 8px;
  height: 100%;
  align-items: center;
`;
